Ext.namespace("orx.lang");

orx.lang.api = 'https://www.googleapis.com/language/translate/v2';
orx.lang.key = 'AIzaSyDXQIKOpECZ0CzthadfhgOp4ZXQEV9yivw';

orx.lang.languages = {
    'AFRIKAANS': 'af',
    'ALBANIAN': 'sq',
    'AMHARIC': 'am',
    'ARABIC': 'ar',
    'ARMENIAN': 'hy',
    'AZERBAIJANI': 'az',
    'BASQUE': 'eu',
    'BELARUSIAN': 'be',
    'BENGALI': 'bn',
    'BIHARI': 'bh',
    'BRETON': 'br',
    'BULGARIAN': 'bg',
    'BURMESE': 'my',
    'CATALAN': 'ca',
    'CHEROKEE': 'chr',
    'CHINESE': 'zh',
    'CHINESE_SIMPLIFIED': 'zh-CN',
    'CHINESE_TRADITIONAL': 'zh-TW',
    'CORSICAN': 'co',
    'CROATIAN': 'hr',
    'CZECH': 'cs',
    'DANISH': 'da',
    'DHIVEHI': 'dv',
    'DUTCH': 'nl',
    'ENGLISH': 'en',
    'ESPERANTO': 'eo',
    'ESTONIAN': 'et',
    'FAROESE': 'fo',
    'FILIPINO': 'tl',
    'FINNISH': 'fi',
    'FRENCH': 'fr',
    'FRISIAN': 'fy',
    'GALICIAN': 'gl',
    'GEORGIAN': 'ka',
    'GERMAN': 'de',
    'GREEK': 'el',
    'GUJARATI': 'gu',
    'HAITIAN_CREOLE': 'ht',
    'HEBREW': 'iw',
    'HINDI': 'hi',
    'HUNGARIAN': 'hu',
    'ICELANDIC': 'is',
    'INDONESIAN': 'id',
    'INUKTITUT': 'iu',
    'IRISH': 'ga',
    'ITALIAN': 'it',
    'JAPANESE': 'ja',
    'JAVANESE': 'jw',
    'KANNADA': 'kn',
    'KAZAKH': 'kk',
    'KHMER': 'km',
    'KOREAN': 'ko',
    'KURDISH': 'ku',
    'KYRGYZ': 'ky',
    'LAO': 'lo',
    'LATIN': 'la',
    'LATVIAN': 'lv',
    'LITHUANIAN': 'lt',
    'LUXEMBOURGISH': 'lb',
    'MACEDONIAN': 'mk',
    'MALAY': 'ms',
    'MALAYALAM': 'ml',
    'MALTESE': 'mt',
    'MAORI': 'mi',
    'MARATHI': 'mr',
    'MONGOLIAN': 'mn',
    'NEPALI': 'ne',
    'NORWEGIAN': 'no',
    'OCCITAN': 'oc',
    'ORIYA': 'or',
    'PASHTO': 'ps',
    'PERSIAN': 'fa',
    'POLISH': 'pl',
    'PORTUGUESE': 'pt',
    'PORTUGUESE_PORTUGAL': 'pt-PT',
    'PUNJABI': 'pa',
    'QUECHUA': 'qu',
    'ROMANIAN': 'ro',
    'RUSSIAN': 'ru',
    'SANSKRIT': 'sa',
    'SCOTS_GAELIC': 'gd',
    'SERBIAN': 'sr',
    'SINDHI': 'sd',
    'SINHALESE': 'si',
    'SLOVAK': 'sk',
    'SLOVENIAN': 'sl',
    'SPANISH': 'es',
    'SUNDANESE': 'su',
    'SWAHILI': 'sw',
    'SWEDISH': 'sv',
    'SYRIAC': 'syr',
    'TAJIK': 'tg',
    'TAMIL': 'ta',
    'TATAR': 'tt',
    'TELUGU': 'te',
    'THAI': 'th',
    'TIBETAN': 'bo',
    'TONGA': 'to',
    'TURKISH': 'tr',
    'UKRAINIAN': 'uk',
    'URDU': 'ur',
    'UZBEK': 'uz',
    'UIGHUR': 'ug',
    'VIETNAMESE': 'vi',
    'WELSH': 'cy',
    'YIDDISH': 'yi',
    'YORUBA': 'yo',
    'UNKNOWN': ''
};

orx.lang.comboData = function () {
    // Generates array data specifically formatted for use in language drop-down combos
    var result = [];
    for (var lang in orx.lang.languages) {
        var code = orx.lang.languages[lang];
        result.push([code, lang]);
    }
    return result;
}();

orx.lang.translate = function (value, from, to, callback) {

    $.ajax({
        url: orx.lang.api,
        dataType: "jsonp",
        data: {
            key: orx.lang.key,
            q: value,
            source: from,
            target: to,
            v: 2.0
        },
        success: function (result) {
            if (result && !result.error) {
                callback(value, result.data.translations[0].translatedText);
            }
        }
    });

}

function __(key, defaultValue) {
    /// <summary>Returns the localized string represented by the key parameter</summary>
    /// <param name="key" type="string">The resource identifier for the desired localized string</param>
    /// <param name="defaultValue" type="string">If supplied, this value will be returned if the identified localized string cannot be found</param>

    if (typeof orx.lang.data == 'undefined')
        return defaultValue || key;

    return orx.lang.data[key] || defaultValue || key;

}


